
const getters = {
    monitoring: state => state.log.monitoring
  }
  export default getters
  